import { SimpleIconList } from '@components'
import { Chip } from '@heroui/react'
import { mySqlToLocal } from '@helpers'

import { 
  AcademicCapIcon, 
  CalendarDaysIcon,
  CubeTransparentIcon,
  RectangleGroupIcon, 
  Square3Stack3DIcon,
  UserIcon, 
} from '@heroicons/react/24/outline'

import { 
  CheckCircleIcon,
  XCircleIcon
} from '@heroicons/react/24/solid'

import PropTypes from 'prop-types'

const WaitingListDetails = ({ details }) => (
  <div className='flex flex-col'>    
    <p className='mb-3 text-lg font-semibold text-content2-foreground'>Details</p>

    <div className='flex items-center py-2 pb-2 border-dotted border-b-1'>
      <CalendarDaysIcon className="w-8 h-8 mr-4 text-indigo-800 shrink-0 dark:text-content2-foreground" />
      <div className="flex items-center justify-between w-full">
        <span className='text-content2-foreground'>Date added to List</span>
        <Chip classNames={{ base: "w-full text-white justify-end", content: "font-semibold" }} size="lg" color="success">
          {mySqlToLocal(details.created_at).format("DD MMM YYYY, HH:mm")}
        </Chip>
      </div>
    </div>
    
    <SimpleIconList 
      iconSize="md" 
      items={[
        { icon: <RectangleGroupIcon className="text-indigo-800 dark:text-content2-foreground" />, caption: `${details.group}` },
        { icon: <AcademicCapIcon className="text-indigo-800 dark:text-content2-foreground" />, caption: `${details.student}` },
        { icon: <UserIcon className="text-indigo-800 dark:text-content2-foreground" />, caption: `${details.guardian}` },
        { icon: <Square3Stack3DIcon className="text-indigo-800 dark:text-content2-foreground" />, caption: `${details.session}` },
        { icon: <CubeTransparentIcon className="text-indigo-800 dark:text-content2-foreground" />, caption: `${details.lesson}` },      
      ]} 
      />
      
      
      {details.has_booked && (
        <div className='flex items-center py-2 pb-2 border-dotted border-t-1'>
          <CheckCircleIcon className="flex justify-center w-8 h-8 mr-4 text-green-500" aria-hidden="true" /> 

          <span className='text-content2-foreground'>
            {`Booked on ${mySqlToLocal(details.booking_slot_created_at).format("DD MMM YYYY, HH:mm")}`}
          </span>
        </div>
      )}

      {!details.has_booked && (
        <div className='flex items-center py-2 pb-2 border-dotted border-t-1'>
          <XCircleIcon className="flex justify-center w-8 h-8 mr-4 text-red-500" aria-hidden="true" />
          <span className='text-content2-foreground'>Not Booked</span>
        </div>
      )}
      
      <div className='mt-8'>
        <p className='mb-3 text-lg font-semibold text-content2-foreground'>Guardians Comments</p>
        <div className='p-4 rounded-lg text-content2-foreground bg-content2'>
          {details.comment || "No comments"}
        </div>
      </div>

  </div>
) 

WaitingListDetails.propTypes = {
  details: PropTypes.object.isRequired,
}

export default WaitingListDetails